<template>
  <div class="webhook-endpoint-delivery-summary mt-3 pt-3">
    <div class="d-flex align-center mb-2">
      <div class="text-subtitle-2">{{ $t('routes.webhookIntegrations.deliverySummary') }}</div>
      <v-spacer />
      <v-progress-circular v-if="loading" indeterminate size="16" width="2" color="primary" :aria-label="$t('common.loading')" />
    </div>

    <div v-if="!loading && !summary" class="text-caption text-grey">
      {{ $t('routes.webhookIntegrations.noDeliverySummary') }}
    </div>

    <template v-else-if="summary">
      <div class="d-flex flex-wrap ga-2 mb-2">
        <v-chip size="small" variant="tonal" color="error">
          {{ $t('routes.webhookIntegrations.failureCount') }}: {{ summary.failure_count || 0 }}
        </v-chip>
        <v-chip
          v-for="statusCode in summary.recent_response_codes || []"
          :key="statusCode"
          size="small"
          variant="tonal"
          color="grey"
        >
          HTTP {{ statusCode }}
        </v-chip>
      </div>

      <v-row density="comfortable">
        <v-col cols="12" md="6">
          <div class="text-caption text-grey">{{ $t('routes.webhookIntegrations.lastSuccessfulDelivery') }}</div>
          <div class="text-body-2">{{ formatSummaryDate(summary.last_successful_delivery_at) }}</div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="text-caption text-grey">{{ $t('routes.webhookIntegrations.lastFailedDelivery') }}</div>
          <div class="text-body-2">{{ formatSummaryDate(summary.last_failed_delivery_at) }}</div>
        </v-col>
      </v-row>

      <div v-if="hasRecentDeliveriesByEventType" class="mt-2">
        <div class="text-caption text-grey mb-1">{{ $t('routes.webhookIntegrations.recentDeliveriesByEventType') }}</div>
        <v-chip
          v-for="item in summary.recent_deliveries_by_event_type"
          :key="item.event_type"
          size="small"
          variant="tonal"
          class="mr-1 mb-1"
        >
          {{ formatEventTypeLabel(item.event_type) }}: {{ item.count }}
        </v-chip>
      </div>

      <div v-if="summary.last_failed_delivery" class="mt-2">
        <v-chip
          :color="getDeliveryStatusColor(summary.last_failed_delivery.status)"
          size="small"
          variant="tonal"
          class="mr-2"
        >
          {{ $t(`routes.webhookIntegrations.deliveryStates.${summary.last_failed_delivery.status}`) }}
        </v-chip>
        <span class="text-caption text-grey">
          {{ summary.last_failed_delivery.last_failure_message || $t('routes.webhookIntegrations.noFailureReason') }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import {
  formatDateTime,
  getDeliveryStatusColor,
  getEventTranslationKey,
} from '@/routes/console/webhook-integrations/WebhookConstants.js';

export default {
  name: 'WebhookEndpointDeliverySummary',
  props: {
    summary: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasRecentDeliveriesByEventType() {
      return (this.summary?.recent_deliveries_by_event_type || []).length > 0;
    },
  },
  methods: {
    getDeliveryStatusColor,
    getEventTranslationKey,
    formatEventTypeLabel(eventType) {
      return this.$t(`routes.webhookIntegrations.events.${getEventTranslationKey(eventType)}`);
    },
    formatSummaryDate(dateString) {
      return formatDateTime(dateString) || this.$t('routes.webhookIntegrations.noDeliveryTimestamp');
    },
  },
}
</script>

<style scoped lang="scss">
.webhook-endpoint-delivery-summary {
  border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>
